import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Ng2DatetimePickerDirective, Ng2Datetime } from 'ng2-datetime-picker';

Ng2Datetime.daysOfWeek = [
    { fullName: 'Sunday', shortName: 'S' },
    { fullName: 'Monday', shortName: 'M' },
    { fullName: 'Tuesday', shortName: 'T' },
    { fullName: 'Wednesday', shortName: 'W' },
    { fullName: 'Thursday', shortName: 'T' },
    { fullName: 'Friday', shortName: 'F' },
    { fullName: 'Saturday', shortName: 'S' }
];

@Component({
  selector: 'datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css']
})
export class DatepickerComponent implements OnInit {
    @Input() fieldName: string;
    @Input() displayFieldName: string;
    @Input() useExactKeyword: boolean;
    @Input() dateOnly = true;
    @Input() useRelativePosition = false;

    @Input()
    set value(value: string) {
        if (value) {
            this.dateInput = value.replace('exact', '');
        }
    }

    @Output() selectedDateChanged: EventEmitter<any> = new EventEmitter();

    @ViewChild(Ng2DatetimePickerDirective)
    private dateTimePicker: Ng2DatetimePickerDirective;

    dateInput: string;

    constructor(private el: ElementRef) {}

    ngOnInit() { }

    onModelChange() { }

    onClose(event: Event) {
        if (event) {
            this.onFilter(event, false);
        }
    }

    onFilter(event: Event, stopPropagation: boolean): void {

        if (stopPropagation) {
            event.stopPropagation();
        }
        if (this.dateInput) {
            const val = this.useExactKeyword ? `${this.dateInput}exact` : this.dateInput;
            this.selectedDateChanged.emit({
                fieldName: this.fieldName,
                value: val
            });
        } else {
            this.selectedDateChanged.emit({
                fieldName: this.fieldName,
                value: ''
            });
        }
    }

    onClick(event: any): void {
        const wrapper = this.el.nativeElement.getElementsByClassName('ng2-datetime-picker-wrapper');
        if (wrapper) {
            wrapper[0].style.position = 'absolute';
        }
    }

    close() {

        const wrapper = this.el.nativeElement.getElementsByClassName('ng2-datetime-picker-wrapper');
        if (wrapper) {
            wrapper[0].style.position = 'relative';
        }

        this.dateTimePicker.hideDatetimePicker();

    }

    reset() {
        this.dateInput = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/datepicker.component.ts